import firebase from 'firebase';

var config = {
  apiKey: "AIzaSyAv_k5TIRHFix6t0MkPShRAC9CWR0ARd9c",
  authDomain: "taksy-pena.firebaseapp.com",
  databaseURL: "https://taksy-pena-test.firebaseio.com",
  projectId: "taksy-pena",
  storageBucket: "taksy-pena.appspot.com",
  messagingSenderId: "553838416898",
  appId: "1:553838416898:web:164ef202f19dda7325431b"
};

const secondaryApp = firebase.initializeApp(config, "Secondary");


export default secondaryApp;


// WEBPACK FOOTER //
// ./src/Components/BD/secondaryApp.js